/**
 * Convert an app/Transifex locale (e.g. zh_CN) to a BCP-47 HTML lang value (zh-CN).
 * Keeps document.lang aligned with the UI so browsers are less likely to offer page translate.
 */
export const toHtmlLang = (locale: string): string => locale.replaceAll('_', '-')
